import { render, staticRenderFns } from "./ActorActionInfo.vue?vue&type=template&id=493e0d81&scoped=true&"
import script from "./ActorActionInfo.vue?vue&type=script&lang=ts&"
export * from "./ActorActionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ActorActionInfo.vue?vue&type=style&index=0&id=493e0d81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493e0d81",
  null
  
)

export default component.exports